import React, { Component } from "react";
import { connect } from "react-redux";
import { GetRequest } from "../common/helper";
import { apiUrl } from "../common/constants";
import { GpsTrack } from "../common/icons/svg";
import { TRACK_BUS, t } from "../../translations/Search";

class Trackbus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectUrl: "",
    };
  }

  componentDidMount() {
    let that = this;
    let route = this.props.route;
    let fromCity = this.props.search.searchParams.fromCity.split("|")[1];
    let toCity = this.props.search.searchParams.toCity.split("|")[1];
    const url =
      apiUrl.track +
      "?tripId=" +
      route.TripID +
      "&chartDate=" +
      route.ChartDate +
      "&fromCity=" +
      fromCity +
      "&toCity=" +
      toCity;
    GetRequest(url)
      .then(function (data) {
        if (data !== "Bus Not Scheduled") {
          let response = data.Incessant_GetGPSLocationURLResult;
          if (response.Success) {
            that.setState({ redirectUrl: response.Url });
          }
        }
      })
      .catch(function (error) {});
  }
  render() {
    if (this.state.redirectUrl) {
      return (
        <div
          style={{
            marginLeft: "10px",
            height: "22px",
            cursor: "pointer",
          }}
          className="trackbus-item"
        >
          <a
            target="_blank"
            className="flex-all-c"
            onClick={(event) => {
              event.preventDefault();
              window.open(this.state.redirectUrl);
            }}
          >
            <GpsTrack />
            {t(TRACK_BUS)}
          </a>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Trackbus);
